module.exports = __webpack_public_path__ + "img/bigwin-v2-bg.132bc151.png";